export default __webpack_public_path__ + "static/media/cemaco.f9b82f12.png";